import axios from 'axios';
import { subirArchivo } from '../paginaWeb/paginaWeb.api';

// Newsletter (beta). Instancia propia de axios: un 403 de este módulo (por ejemplo, otro
// cliente) no tiene que cerrar la sesión como hace la instancia general.
// En local se puede apuntar a un backend propio con REACT_APP_NEWSLETTER_API_URL.
const BASE = process.env.REACT_APP_NEWSLETTER_API_URL || process.env.REACT_APP_BACKEND_URL || 'http://localhost:8081';

const api = axios.create({ baseURL: `${BASE.replace(/\/$/, '')}/api/newsletter` });
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('authLisualToken');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const errorMsg = (e) => e?.response?.data?.message || e?.message || 'Algo salió mal';
const d = (p) => p.then((r) => r.data);

export const nl = {
  config: () => d(api.get('/config')),
  // contactos
  contacts: (customerId) => d(api.get('/contacts', { params: { customerId } })),
  addContact: (customerId, c) => d(api.post('/contacts', { ...c, customerId })),
  updateContact: (id, c) => d(api.put(`/contacts/${id}`, c)),
  deleteContact: (id) => d(api.delete(`/contacts/${id}`)),
  importContacts: (customerId, rows) => d(api.post('/contacts/import', { customerId, rows })),
  // campañas
  campaigns: (customerId) => d(api.get('/campaigns', { params: { customerId } })),
  createCampaign: (body) => d(api.post('/campaigns', body)),
  campaign: (id) => d(api.get(`/campaigns/${id}`)),
  updateCampaign: (id, patch) => d(api.put(`/campaigns/${id}`, patch)),
  deleteCampaign: (id) => d(api.delete(`/campaigns/${id}`)),
  activate: (id) => d(api.post(`/campaigns/${id}/activate`)),
  pause: (id) => d(api.post(`/campaigns/${id}/pause`)),
  test: (id, body) => d(api.post(`/campaigns/${id}/test`, body)),
  sendNow: (id) => d(api.post(`/campaigns/${id}/send-now`)),
  history: (id) => d(api.get(`/campaigns/${id}/history`)),
  preview: (campaign, opts = {}) => d(api.post('/preview', { campaign, ...opts })),
  preset: (id, params) => d(api.get(`/presets/${id}`, { params })),
  // WhatsApp (pago) y plantillas de Meta
  waStatus: (customerId) => d(api.get('/wa/status', { params: { customerId } })),
  waCheckout: (body) => d(api.post('/wa/checkout', body)),
  waConfirm: (body) => d(api.post('/wa/confirm', body)),
  waPortal: (body) => d(api.post('/wa/portal', body)),
  waCortesia: (body) => d(api.post('/wa/cortesia', body)),
  waTemplates: (customerId) => d(api.get('/wa/templates', { params: { customerId } })),
  waPreview: (body) => d(api.post('/wa/templates/preview', body)),
  waCreateTemplate: (body) => d(api.post('/wa/templates', body)),
  waDeleteTemplate: (id) => d(api.delete(`/wa/templates/${id}`)),
};

/** Sube imágenes o documentos del newsletter a Firebase Storage. */
export const subir = (file, customerId) => subirArchivo(file, `newsletter/${customerId || 'sin-cliente'}`);
